import { Button } from '@/components/ui/button'
import { Check, Clock, Droplet } from 'lucide-react'

const formatBRL = (n: number) =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(n)

export function BookingServiceSelection({ flow }: { flow: any }) {
  const services = flow.servicesQuery.data ?? []

  const toggleService = (id: string) => {
    if (flow.selectedServiceIds.includes(id)) {
      flow.setSelectedServiceIds(flow.selectedServiceIds.filter((s: string) => s !== id))
    } else {
      flow.setSelectedServiceIds([...flow.selectedServiceIds, id])
    }
  }

  return (
    <div className="space-y-4 animate-in fade-in slide-in-from-bottom-4">
      <h2 className="text-lg font-semibold">Quais serviços você deseja?</h2>
      
      <div className="space-y-3">
        {services.length ? (
          services.map((s: any) => {
            const isSelected = flow.selectedServiceIds.includes(s.id)
            return (
              <button
                key={s.id}
                onClick={() => toggleService(s.id)}
                className={`w-full text-left p-4 rounded-xl border transition-all duration-300 flex items-center justify-between ${
                  isSelected 
                    ? 'border-blue-500 bg-blue-500/10' 
                    : 'border-slate-800 hover:border-slate-700 bg-slate-800/50'
                }`}
              >
                <div className="flex items-center gap-4">
                  <div className={`w-10 h-10 rounded-lg flex items-center justify-center shrink-0 ${isSelected ? 'bg-blue-500/20 text-blue-500' : 'bg-slate-700 text-slate-400'}`}>
                    {isSelected ? <Check className="w-5 h-5" /> : <Droplet className="w-5 h-5" />}
                  </div>
                  <div>
                    <div className="font-semibold text-slate-100">{s.name}</div>
                    <div className="text-xs text-slate-400 flex items-center gap-1.5 mt-1">
                      <Clock className="w-3.5 h-3.5" />
                      {s.estimated_time_minutes} min
                    </div>
                  </div>
                </div>
                <div className="font-bold text-slate-100">
                  {formatBRL(Number(s.price))}
                </div>
              </button>
            )
          })
        ) : (
          <div className="text-center py-10 bg-slate-800/50 rounded-xl border border-dashed border-slate-700">
            <p className="text-slate-400 text-sm">Nenhum serviço disponível.</p>
          </div>
        )}
      </div>

      <div className="pt-4 flex justify-end">
        <Button 
          disabled={flow.selectedServiceIds.length === 0} 
          onClick={() => flow.setStep(2)}
          className="w-full"
        >
          Avançar
        </Button>
      </div>
    </div>
  )
}
